import {Box, Divider, Stack} from '@mui/material';
import {ErrorState, StyledCard} from 'presentation/components';
import {Drawer} from 'presentation/components/Drawer';
import {Timeline} from 'presentation/components/Timeline';
import {translations} from 'presentation/translations-new';
import React from 'react';

import {ConsultProtocolsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {useConsultProtocolsTrack} from '../../../hooks/useConsultProtocolsTrack';
import {ProtocolDetailLoading} from '../components/Loading';
import {ProtocolStatus} from '../components/Status';
import {ProtocolStatusDrawerProps} from './types';

const {details, close, failToLoadTitle, failToLoadDescription} = translations['pt-br'].commons;

export function ProtocolStatusDrawer({
	protocol,
	onCloseDrawer,
	onOpenDrawer,
	openDrawer,
}: ProtocolStatusDrawerProps) {
	const {
		protocolDetailsList,
		showDescription,
		protocolDescription,
		lastUpdate,
		timelineContent,
		refetch,
		isError,
		isLoading,
		shouldShowContent,
		refundInfoList,
		shouldShowTimeline,
	} = useConsultProtocolsTrack(protocol);

	return (
		<Drawer.Root
			open={openDrawer}
			onClose={onCloseDrawer}
			onOpen={onOpenDrawer}
			width={'396px'}
			customMaxHeight={'90%'}>
			<Drawer.Header
				onClose={onCloseDrawer}
				title={details}
				closeBtnDataTagId={
					ConsultProtocolsTaggingEnum.CLICK_ICONE_FECHAR_DRAWER_CONSULTA_PROTOCOLOS
				}
			/>

			{isError ? (
				<Box flex={1} pb={4}>
					<ErrorState
						title={failToLoadTitle}
						description={failToLoadDescription}
						handleRefresh={refetch}
					/>
				</Box>
			) : null}

			{isLoading ? <ProtocolDetailLoading /> : null}

			{shouldShowContent ? (
				<Drawer.Content>
					<Stack gap={2}>
						<ProtocolStatus
							protocol={protocol}
							lastUpdate={shouldShowTimeline ? lastUpdate : undefined}
						/>
						{shouldShowTimeline ? (
							<Stack mb={3}>
								<Timeline content={timelineContent} customPaddingBottom />
								<Divider />
							</Stack>
						) : null}
					</Stack>
					<Stack gap={1} mt={shouldShowTimeline ? 0 : 3}>
						<StyledCard.Content
							sx={{flexDirection: 'column'}}
							list={protocolDetailsList}
						/>
						{showDescription ? <StyledCard.Content list={protocolDescription} /> : null}
						<StyledCard.Content
							list={refundInfoList}
							sx={{flexDirection: 'column', gap: 2}}
						/>
					</Stack>
				</Drawer.Content>
			) : null}

			<Drawer.Footer
				secondButtonDataTagId={
					ConsultProtocolsTaggingEnum.CLICK_BOTAO_FECHAR_DRAWER_CONSULTA_PROTOCOLOS
				}
				secondButtonTitle={close}
				secondButtonOnClick={onCloseDrawer}
				hideFirstButton
			/>
		</Drawer.Root>
	);
}
